import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import LocalText from "../common/LocalText";

const POSITIONS = [
  { label: "Left",   left: "15%"  },
  { label: "Center", left: "50%"  },
  { label: "Right",  left: "85%"  },
];

const PositionPreviewModal = ({ open, onClose, imageUrl, positionThumbnails = [] }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { borderRadius: 3, overflow: "hidden" } }}
    >
      <DialogTitle sx={{ bgcolor: "primary.main", color: "white", py: 2, px: 3, pr: 6 }}>
        <Typography variant="h6" fontWeight={700} component="div" lineHeight={1}>
          <LocalText>Position Preview</LocalText>
        </Typography>
        <IconButton
          onClick={(e) => { e.currentTarget.blur(); onClose(); }}
          size="small"
          sx={{
            position: "absolute",
            right: 10,
            top: 10,
            color: "white",
            "&:hover": { bgcolor: "rgba(255,255,255,0.15)" },
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ p: 3, bgcolor: "white" }}>
        {/* Padded wrapper gives space around the image */}
        <Box sx={{ p: 1.5, mt: 1, bgcolor: "grey.100", borderRadius: 3 }}>
          <Box
            sx={{
              position: "relative",
              width: "100%",
              height: { xs: 200, sm: 300 },
              borderRadius: 2,
              overflow: "hidden",
              bgcolor: "grey.300",
            }}
          >
            {imageUrl ? (
              <Box
                component="img"
                src={imageUrl}
                alt="Media Image"
                sx={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
              />
            ) : (
              <Box
                sx={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography variant="h6" color="text.secondary" fontWeight={600}>
                  <LocalText>Media Image</LocalText>
                </Typography>
              </Box>
            )}

            {/* Position circles at 75% height */}
            {POSITIONS.map(({ label, left }, index) => {
              const thumbUrl = positionThumbnails[index];
              return (
                <Box
                  key={label}
                  sx={{
                    position: "absolute",
                    top: "75%",
                    left,
                    transform: "translate(-50%, -50%)",
                    width: { xs: 44, sm: 56 },
                    height: { xs: 44, sm: 56 },
                    borderRadius: "50%",
                    border: "2.5px solid white",
                    boxShadow: "0 4px 14px rgba(0,0,0,0.4)",
                    overflow: "hidden",
                    bgcolor: "primary.main",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {thumbUrl ? (
                    <Box
                      component="img"
                      src={thumbUrl}
                      alt={label}
                      sx={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
                    />
                  ) : (
                    <Typography
                      variant="caption"
                      fontWeight={700}
                      sx={{ color: "white", fontSize: "0.68rem", lineHeight: 1, textAlign: "center" }}
                    >
                      {label}
                    </Typography>
                  )}
                </Box>
              );
            })}
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default PositionPreviewModal;
